export enum UpdateManyTestsAction {
  Delete = 'delete',
  Restore = 'restore',
}
